import { render, staticRenderFns } from "./GiftsDashboard.vue?vue&type=template&id=2e70ebe6&scoped=true&"
import script from "./GiftsDashboard.vue?vue&type=script&lang=js&"
export * from "./GiftsDashboard.vue?vue&type=script&lang=js&"
import style0 from "./GiftsDashboard.vue?vue&type=style&index=0&id=2e70ebe6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e70ebe6",
  null
  
)

export default component.exports